class MandateConfirmationController {
    $onInit() {
        if (this.transaction.transactionStatus === 'success') {
            this.viewState = 'state-mandate-success'
        } else if (this.transaction.transactionStatus === 'failure') {
            this.viewState = 'state-mandate-failure'
        } else {
            this.viewState = 'state-mandate-default'
        }
    }
}

export default {
    template: require('./mandateConfirmation.jade')(),
    controller: MandateConfirmationController,
    bindings: {
        transaction: '<',
    },
}



// WEBPACK FOOTER //
// ./src/states/mandateConfirmation/mandateConfirmation.component.js